import React from 'react';
import $ from 'jquery';
import {confirmAlert} from 'react-confirm-alert';
import APPCONFIG from '../constants/Config';

export async function fetchOpenWorkOrdersForInventory(inventoryPkey, excludeWorkOrderPkey = null) {
	if (!inventoryPkey) {
		return [];
	}
	let url = `${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/inventories/${inventoryPkey}/open_work_orders`;
	if (excludeWorkOrderPkey) {
		url += `?exclude_work_order=${encodeURIComponent(excludeWorkOrderPkey)}`;
	}
	try {
		const data = await $.ajax({
			type: 'GET',
			url,
			dataType: 'json',
		});
		const payload = data && typeof data.response !== 'undefined' ? data.response : data;
		return Array.isArray(payload?.items) ? payload.items : [];
	} catch (e) {
		return [];
	}
}

function OpenWorkOrderWarningModal({items, itemLabel, onConfirm, onCancel}) {
	const woCount = items.length;
	const woLabel = woCount === 1 ? 'an open work order' : `${woCount} open work orders`;

	return (
		<div className="react-confirm-alert">
			<div className="react-confirm-alert-body open-work-order-warning-modal">
				<h1>Item on open work order</h1>
				<p className="open-work-order-warning-intro">
					<strong>{itemLabel}</strong> is already on {woLabel}:
				</p>
				<ul className="open-work-order-warning-list">
					{items.map((wo) => (
						<li key={wo.pkey} className="open-work-order-warning-item">
							<div className="open-work-order-warning-item-main">
								<span className="open-work-order-warning-wo">WO #{wo.pkey}</span>
								<span className="open-work-order-warning-status">{wo.status || 'Open'}</span>
							</div>
							{wo.customer_name ? (
								<div className="open-work-order-warning-customer">{wo.customer_name}</div>
							) : null}
							{wo.sku ? (
								<div className="open-work-order-warning-sku">{wo.sku}</div>
							) : null}
						</li>
					))}
				</ul>
				<p className="open-work-order-warning-prompt">Add it anyway?</p>
				<div className="react-confirm-alert-button-group open-work-order-warning-actions">
					<button type="button" className="btn btn-primary btn-sm" style={{ backgroundColor: '#16a34a' }} onClick={onConfirm}>
						Add anyway
					</button>
					<button type="button" className="btn btn-secondary btn-sm" onClick={onCancel}>
						Cancel
					</button>
				</div>
			</div>
		</div>
	);
}

export function confirmIfOnOpenWorkOrder(items, itemLabel = 'This item') {
	if (!items || items.length === 0) {
		return Promise.resolve(true);
	}
	return new Promise((resolve) => {
		confirmAlert({
			customUI: ({onClose}) => (
				<OpenWorkOrderWarningModal
					items={items}
					itemLabel={itemLabel}
					onConfirm={() => {
						onClose();
						resolve(true);
					}}
					onCancel={() => {
						onClose();
						resolve(false);
					}}
				/>
			),
		});
	});
}

export async function guardOpenWorkOrderBeforeAdd(inventoryPkey, itemLabel, excludeWorkOrderPkey = null) {
	const items = await fetchOpenWorkOrdersForInventory(inventoryPkey, excludeWorkOrderPkey);
	return confirmIfOnOpenWorkOrder(items, itemLabel);
}
